import { ErrorOutline } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';

import { LANG } from '../../services/Config';
import Typography from '../Typography';

const useStyles = makeStyles()(
  ({ palette, spacing }, _params, classes: any) => ({
    errorContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      padding: spacing(2),
      textAlign: 'center',
      minHeight: '50vh',
      marginBottom: spacing(8),
      [`&.${classes.inline}`]: {
        minHeight: 0,
        marginBottom: 0,
      },
    },
    errorIcon: {
      color: palette.accent.main,
      marginBottom: spacing(1),
    },
    inline: {},
  }),
);

interface ErorrProps {
  error?: {
    message?: string;
    networkError?: object;
  };
  inline?: boolean;
}

const Erorr = ({ error, inline }: ErorrProps) => {
  const { classes, cx } = useStyles();
  const { appStrings } = LANG;

  const text = error?.networkError
    ? appStrings.ERROR.NETWORK
    : appStrings.ERROR.MAIN;

  return (
    <div className={cx(classes.errorContainer, inline && classes.inline)}>
      <ErrorOutline className={classes.errorIcon} />
      <Typography variant="p1">{text}</Typography>
    </div>
  );
};

export default Erorr;
